<h1 mat-dialog-title  oneDialogTitle>Resend notifications</h1>

<div mat-dialog-content oneDialogContent class="view-feedback-dialog">

    <mat-card class="one-card-flat" oneCard style="position:relative">
        <one-table>
          <one-table-content>
            <mat-table [dataSource]="dataSource" matTableExporter matSort multiTemplateDataRows class="feedback-tbl">

              <ng-container matColumnDef="CustomerId">
                <mat-header-cell *matHeaderCellDef mat-sort-header title="Account ID"><span>Account ID</span></mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div class="truncate-text" [title]="element.CustomerId">{{ element.CustomerId }}</div>
                </mat-cell>
              </ng-container>
              
              <ng-container matColumnDef="CustomerName">
                <mat-header-cell *matHeaderCellDef mat-sort-header title="Account Name"><span>Account name</span></mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div class="truncate-text" [title]="element.CustomerName">{{ element.CustomerName }}</div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="CustomerContactName">
                <mat-header-cell *matHeaderCellDef mat-sort-header title="Account contact name"><span>Account contact name</span></mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div class="truncate-text" [title]="element.CustomerContactName">{{ element.CustomerContactName }}</div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="CustomerContactEmail">
                <mat-header-cell *matHeaderCellDef mat-sort-header title="Account contact email"><span>Account contact email</span></mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div class="truncate-text" [title]="element.CustomerContactEmail">{{ element.CustomerContactEmail }}</div>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns" class="one-element-row"></mat-row>
            </mat-table>
          </one-table-content>
        </one-table>
    </mat-card>

    <div mat-dialog-actions oneDialogActions>
        <div class="left-button">
            <!-- Left side buttons -->
        </div>
        <div class="right-button">
            <button color="primary" mat-flat-button (click)="resend()">Resend</button>
            <button mat-stroked-button one-secondary-button [mat-dialog-close]="false">Cancel</button>
        </div>
    </div>
</div>
